angular.module('shared').factory('MasqueradingService', function() {
  return {
    isMasquerading: function() {
      return window.masquerading;
    }
  };
});
